import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { TranslationService } from './translation.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { Languages } from '../../../enums/languages';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private html: HTMLElement;
  private readonly languageKey: string = 'lang';
  private readonly defaultLanguageKey: string = Languages.EN;
  private language: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public currentLanguage: Observable<string> = this.language.asObservable();

  constructor(
    private translationService: TranslationService,
    private localStorageService: LocalStorageService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.html = this.document.getElementsByTagName('html')[0];
    this.language.next(this.localStorageService.getItem(this.languageKey) || this.defaultLanguageKey);
  }

  initAppLanguage(): void {
    this.translationService.setDefaultLang(this.language.getValue());
    this.setLanguage(this.language.getValue());
  }

  changeLanguage(lang: string): void {
    this.translationService.use(lang);
    this.setLanguage(lang);
  }

  isArabic(): boolean {
    return this.language.getValue() === Languages.AR;
  }

  private setLanguage(lang: string): void {
    this.language.next(lang);
    this.localStorageService.setItem(this.languageKey, lang);
    this.isArabic();
    this.updateLayout();
  }

  private updateLayout(): void {
    this.html.lang = this.language.getValue();
    this.document.body.dir = this.getDirection();
  }

  private getDirection(): string {
    return this.language.getValue() === Languages.AR ? 'rtl' : 'ltr';
  }
}
